<template>
  <div>
    <v-container>
      <v-row class="mb-4">
        <h2>Introductory Information</h2>
      </v-row>

      <v-row class="mb-3">
        <span style="font-weight: bold">Note:</span>&nbsp;this report is a formal report and must be
        written&nbsp;<span style="font-weight: bold">individually!</span>
      </v-row>

      <v-row>
        <v-simple-table>
          <thead>
            <tr v-for="field in fields" :key="field">
              <td style="width: 220px">
                {{ field.name }}
              </td>
              <td>
                <v-text-field v-model="inputs[field.inputKey]" />
              </td>
            </tr>
          </thead>
        </v-simple-table>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'UOttawaIntroductoryInfoTask',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        title: null,
        author: null,
        partner: null,
        demonstrator: null,
        date: null,
      },
      fields: [
        {name: 'Experiment Title: ', inputKey: 'title'},
        {name: "Author's Name: ", inputKey: 'author'},
        {name: "Submitting Author's Partner: ", inputKey: 'partner'},
        {name: "TA's (Demonstrator's) Name: ", inputKey: 'demonstrator'},
        {name: 'Date Experiment Performed: ', inputKey: 'date'},
      ],
    };
  },
};
</script>

<style scoped></style>
